import React from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { SelectOption } from '@lib/components/Select/types';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
import styles from './TagsInput.module.scss';

type Props = {
  tagsValue: SelectOption[];
  handleRemoveTag: (v: string) => void;
  // Adds spacing below the selected tags. Off by default so the row hugs the
  // next element; the document form opts in to separate it from the AI tags row.
  hasBottomSpace?: boolean;
};

export default function TagsRow({
  tagsValue,
  handleRemoveTag,
  hasBottomSpace = false,
}: Props) {
  return (
    <div
      className={classNames(styles.tagsRow, {
        [styles.tagsRowBottomSpace]: hasBottomSpace,
      })}
    >
      {tagsValue?.map((tag: SelectOption) => (
        <div key={uuidv4()}>
          <Chip
            label={tag?.label}
            type={ChipTypes.chipBlack}
            onClose={() => handleRemoveTag(tag?.value as string)}
          />
        </div>
      ))}
    </div>
  );
}
